import { render, staticRenderFns } from "./HandoverMatterAdd.vue?vue&type=template&id=c4bbda38&scoped=true&"
import script from "./HandoverMatterAdd.vue?vue&type=script&lang=ts&"
export * from "./HandoverMatterAdd.vue?vue&type=script&lang=ts&"
import style0 from "./HandoverMatterAdd.vue?vue&type=style&index=0&id=c4bbda38&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4bbda38",
  null
  
)

export default component.exports